import React from 'react';
import PropTypes from 'prop-types';

const PrintDate = (props) => {
  const { format, style, className } = props;

  let { time } = props;
  time = parseInt(time, 10);

  const a = new Date(time);
  const year = a.getFullYear();
  const month = a.getMonth() + 1;
  const date = a.getDate();
  const hour = a.getHours();
  let min = a.getMinutes();
  const sec = a.getSeconds();

  if (min < 10) {
    min = `0${min}`;
  }

  let formatedDate = '';

  if (time.length > 0) {
    switch (format) {
      case 'd.m.Y':
        formatedDate = `${date}.${month}.${year}`;
        break;
      case 'd.m.Y H:i:s':
        formatedDate = `${date}.${month}.${year} ${hour}:${min}:${sec}`;
        break;
      default:
        formatedDate = `${date}.${month}.${year} ${hour}:${min}:${sec}`;
    }
  }

  return (
    <div style={style} className={className}>
      {formatedDate}
    </div>
  );
};

PrintDate.propTypes = {
  format: PropTypes.string,
  time: PropTypes.number.isRequired,
  style: PropTypes.shape,
  className: PropTypes.string,
};

PrintDate.defaultProps = {
  format: '',
  style: {},
  className: '',
};

export default PrintDate;
